
import ProgramsModel from '../models/ProgramsModel'

export const adminLoadPrograms = () => {
    return (dispatch) => {
        ProgramsModel.findAll((result) => {
            dispatch({type: 'ADMIN_PROGRAMS_LOAD', items: result})
        })
    }
}

export const adminLoadProgramsItem = (id) => {
    return (dispatch) => {
        if (!id) return dispatch(adminUpdateProgramsForm(ProgramsModel.dispense()))
        ProgramsModel.find(id, (result) => {
            if (result.locals.length) {
                result.center = [result.locals[0].x, result.locals[0].y];
                result.zoom = 14; 
                result.address = result.locals[0].address;
            }
            dispatch(adminUpdateProgramsForm(result))
        })
    }
}

export const adminDelProgramsItem = (item) => {
    return (dispatch) => {
        ProgramsModel.remove(item, (result) => {
            dispatch(adminLoadPrograms())
        })
    }
}

export const adminStoreProgramsItem = (formData) => {
    return (dispatch) => {
        ProgramsModel.store(formData, (result) => {
            if (result.item) formData['id'] = result.item.id
            dispatch(adminUpdateProgramsForm(formData, true, result.error))
        })
    }
}

export const adminUpdateProgramsForm = (formData, complete = false, error = '') => {
    return {
        type: 'ADMIN_UPDATE_PROGRAMS_FORM',
        complete,
        error,
        formData
    }
}



// WEBPACK FOOTER //
// ./src/actions/adminPrograms.js